module.exports = __webpack_public_path__ + "media/images/home-top-5546d60d2027afaaaad3eca715b16163.png";